import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import BrandingWizard from '../../components/Setup/BrandingWizard/BrandingWizard.module';
import { ROUTES } from '../../utils/routes';

function SetupBrandingView() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Try to go back to the previous route in history
    // If there's no previous route (e.g., user opened this page directly), 
    // navigate to the setup dashboard
    try {
      // Check if we can go back in history
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1); // Go back to the previous route
      } else {
        // No previous route in history, go to the setup dashboard
        navigate(ROUTES.SETUP_SIMPLIFIED_DASHBOARD);
      }
    } catch (error) {
      // Fallback in case of any issues
      console.error('Navigation error :', error);
      navigate(ROUTES.SETUP_SIMPLIFIED_DASHBOARD);
    }
  };

  return (
    <div className="mx-auto">
      {/* Back button */}
      <div className="mb-6">
        <button
          onClick={handleGoBack}
          className="flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-700 transition-colors hover:bg-gray-50"
        >
          <ArrowLeftIcon className="mr-2 h-5 w-5" />
          Retour
        </button>
      </div>

      {/* Presentation section */}
      <div className="mb-8 rounded-lg bg-white p-8 shadow-md">
        <h1 className="mb-6 text-3xl font-bold text-gray-900">
          Personnalisation de l'image de marque
        </h1>
        <div className="prose prose-lg text-gray-700">
          <p>
            Personnalisez l'identité visuelle de votre entreprise pour renforcer votre marque 
            auprès de vos copropriétaires et clients. Cette configuration vous permet de :
          </p>
          <ul className="mt-4 space-y-2">
            <li>• Définir les couleurs de votre charte graphique</li>
            <li>• Ajouter votre logo d'entreprise</li>
            <li>• Configurer les informations de votre référent mutations/location</li>
            <li>• Personnaliser l'apparence de vos communications</li>
          </ul>
          <p className="mt-4">
            Ces paramètres seront appliqués sur toutes vos communications, newsletters, 
            et pages publiques pour une expérience cohérente avec votre image de marque.
          </p>
        </div>
      </div>

      {/* Branding Wizard */}
      <BrandingWizard />
    </div>
  );
}

export default SetupBrandingView; 